import React, { Suspense } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { startWebSettings, URLRoutes } from './config';
import { AdditionalDriverRoutes, AgreementPdfRoutes, ClientConfirmationRoutes, DefaultMenuRoutes, HomeRoutes, OpenedAgreementRoutes, PaymentRoutes, QuotationRoutes, RequestSignatureRoutes, ReservationSecurity, SearchRoutes, SurveyRoutes } from './routes';
import { IdleTimer, DotCircleSpinner } from './components';
import { useDispatch, useSelector } from 'react-redux';
import { startSetLocalData } from './store/localService';

export const AppRouter = () => {
    const localService = useSelector(store => store.localService);
    const dispatch = useDispatch();
    React.useEffect(() => {
        startWebSettings();
        dispatch( startSetLocalData() );
    }, []);

    if(localService == null) return;

  return (
    <Suspense fallback={<div className='loader-container'><DotCircleSpinner /></div>}>
        <Routes>
            <Route path={URLRoutes.baseUrl()+"*"} element={
                <Routes>
                    <Route element={<IdleTimer />}>
                        <Route path={`/search/*`} element={ <SearchRoutes /> } />

                        <Route element={<ReservationSecurity />}>
                            <Route path={`/client/*`} element={ <ClientConfirmationRoutes /> } />
                            <Route path={`/quotation/*`} element={ <QuotationRoutes /> } />
                            <Route path={`/signature/*`} element={ <RequestSignatureRoutes /> } />
                            <Route path={`/payments/*`} element={ <PaymentRoutes /> } />
                            <Route path={`/agreement-pdf/*`} element={ <AgreementPdfRoutes /> } />
                            <Route path={`/opened-agreement/*`} element={ <OpenedAgreementRoutes /> } />
                            <Route path={`/survey/*`} element={ <SurveyRoutes /> } />
                            <Route path={`/additional-driver/*`} element={ <AdditionalDriverRoutes /> } />
                        </Route>
                    </Route>

                    <Route path='/*' element={ <HomeRoutes /> } />
                </Routes>
            } />
            <Route path={'/*'} element={<DefaultMenuRoutes />} />
        </Routes>
    </Suspense>
  )
}
